import { render, staticRenderFns } from "./Generos.vue?vue&type=template&id=28a431bd&"
import script from "./Generos.vue?vue&type=script&lang=js&"
export * from "./Generos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports